import { Form, Input } from '@opengov/component-library/dist';
import { IConditionalReportColumn } from '@opengov/reporting-types';
import {
  createNewCondition,
  createNewConditionBetween,
  EConditionalComparisonOperators
} from '@opengov/reporting-types/src/reportColumns-immer';
import { debounce } from 'lodash';
import React from 'react';

import {
  ConditionalPreviewTable,
  IConditionalPreviewTable
} from '../../../../createConditional/components/ConditionalPreviewTable';
import { ICurrentConditionalSetupRecord } from '../../../../createConditional/state';
import { IReportLocale } from '../../../../locale';
import styles from '../CreateConditionalModal.scss';

export interface IFourthConditionalStep {
  reportLocaleText: IReportLocale;
  conditional: IConditionalReportColumn<any>;
  currentConditionSetup: ICurrentConditionalSetupRecord<any>;
  conditionalPreviewTableProps: IConditionalPreviewTable;
  fetchPreviewData(): void;
  addCondition(condition: any): void;
  updateColumnName(name: string): void;
}

export class Step4 extends React.Component<IFourthConditionalStep> {
  constructor(props) {
    super(props);
    this.getConditionalPreviewTableData = debounce(this.getConditionalPreviewTableData, 500);
  }

  componentDidMount() {
    this.addConditionToList();
    this.getConditionalPreviewTableData();
  }

  addConditionToList = () => {
    const { currentConditionSetup } = this.props;
    const betweenIsCurrentOperator =
      currentConditionSetup.operator && currentConditionSetup.operator === EConditionalComparisonOperators.between;
    //Default condition will be if operator match
    let condition = createNewCondition({
      operator: currentConditionSetup.operator,
      matchValue: currentConditionSetup.matchValue,
      returnedValue: currentConditionSetup.returnedValue
    });
    if (betweenIsCurrentOperator) {
      condition = createNewConditionBetween({
        operator: EConditionalComparisonOperators.between,
        lowerBound: currentConditionSetup.lowerBound,
        upperBound: currentConditionSetup.upperBound,
        returnedValue: currentConditionSetup.returnedValue
      });
    }
    this.props.addCondition(condition);
  };

  getConditionalPreviewTableData = () => {
    this.props.fetchPreviewData();
  };

  updateColumnName = (e) => {
    this.props.updateColumnName(e);
    this.getConditionalPreviewTableData();
  };

  render() {
    const {
      conditional,
      conditionalPreviewTableProps,
      reportLocaleText: {
        calculations: {
          conditionalModal: { newColumn, newColumnName, preview }
        }
      }
    } = this.props;
    return (
      <div className={styles.previewGroup}>
        <div className={styles.newColumnName}>
          <Form.Item label={newColumnName}>
            <Form.CharacterCounter
              maxCount={30}
              currentCount={(conditional.displayName && conditional.displayName.length) || 0}
            />
            <Input.Text
              placeholder={newColumn}
              value={conditional.displayName}
              onChange={(e) => {
                this.updateColumnName(e);
              }}
              dataTest="conditional-column-name"
            />
          </Form.Item>
        </div>
        <Form.Item label={preview}>
          <div className={styles.previewTable} data-test="column-preview-table">
            <ConditionalPreviewTable {...conditionalPreviewTableProps} />
          </div>
        </Form.Item>
      </div>
    );
  }
}
